/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsErrorResponse } from "./models/ErrorResponse";
import type { ModelsPublicBarbersOutput } from "./models/PublicBarbersOutput";

export type GetApiPublicTabletBarbersPathParams = {
    /**
     * @description ID филиала
     * @type integer
    */
    branch_id: number;
};

export enum GetApiPublicTabletBarbersQueryParamsServiceTypeEnum {
    adult = "adult",
    child = "child",
    adult_child = "adult_child"
}

export type GetApiPublicTabletBarbersQueryParams = {
    /**
     * @description ID филиала
     * @minLength 1
     * @type integer
    */
    branch_id: number;
    /**
     * @description Текущий день (YYYY-MM-DD); другая дата отклоняется
     * @type string | undefined
    */
    date?: string;
    /**
     * @description ID услуги для проверки доступности
     * @type integer | undefined
    */
    service_id?: number;
    /**
     * @description Тип услуги для проверки доступности
     * @type string | undefined
    */
    service_type?: GetApiPublicTabletBarbersQueryParamsServiceTypeEnum;
};

/**
 * @description OK
*/
export type GetApiPublicTabletBarbers200 = ModelsPublicBarbersOutput;

/**
 * @description Некорректный branch_id, date или услуга
*/
export type GetApiPublicTabletBarbers400 = ModelsErrorResponse;

/**
 * @description Некорректный филиальный контекст
*/
export type GetApiPublicTabletBarbers403 = ModelsErrorResponse;

/**
 * @description Филиал или компания недоступны
*/
export type GetApiPublicTabletBarbers404 = ModelsErrorResponse;

/**
 * @description Ошибка определения филиала или подбора мастеров
*/
export type GetApiPublicTabletBarbers500 = ModelsErrorResponse;

export type GetApiPublicTabletBarbersQueryResponse = GetApiPublicTabletBarbers200;

export type GetApiPublicTabletBarbersQuery = {
    Response: GetApiPublicTabletBarbers200;
    PathParams: GetApiPublicTabletBarbersPathParams;
    QueryParams: GetApiPublicTabletBarbersQueryParams;
    Errors: GetApiPublicTabletBarbers400 | GetApiPublicTabletBarbers403 | GetApiPublicTabletBarbers404 | GetApiPublicTabletBarbers500;
};